import type { DataNode, TreeProps } from 'antd/es/tree';
import deepClone from 'lodash.clonedeep'

export const getKeys = (data: DataNode[]): React.Key[] => {

    const keys = new Set<React.Key>()
    
    const addKeysRecursively = (dataNode: DataNode) => {

        keys.add(dataNode.key)

        if(!dataNode.children || dataNode.children.length === 0) return 

        dataNode.children.forEach(ele => {
            return addKeysRecursively(ele)
        })
    }
  
  
    data.forEach(ele => {
        addKeysRecursively(ele)
    })
  
    const result = Array.from(keys.values());
  
    return result;
}

export const find = (title: string, data: DataNode[]): DataNode[] => {

    let dataCopy = deepClone(data)

    const includes = (source, target) => source?.toString().toUpperCase().includes(target?.toUpperCase())

    const filterRecursively = (dataNode: DataNode): DataNode => {
        
        if(!dataNode.children || dataNode.children.length === 0){            
            return dataNode
        } 

        dataNode.children = dataNode.children.filter(ele => {
            const aux = filterRecursively(ele) 
            
            if(aux.children) ele.children = aux.children
            
            return includes(aux?.title, title) || aux?.children?.length > 0
        })

        return dataNode
    }
    
    const result = dataCopy.filter(ele => {
        const aux = filterRecursively(ele)

        if(aux.children) ele.children = aux.children

        return includes(aux?.title, title) || aux?.children?.length > 0
    })
  
    return result;
}